export default "__VITE_PUBLIC_ASSET__599e5b3b__"